import { render, staticRenderFns } from "./unit-introduce.vue?vue&type=template&id=428b67e2&scoped=true&"
import script from "./unit-introduce.vue?vue&type=script&lang=js&"
export * from "./unit-introduce.vue?vue&type=script&lang=js&"
import style0 from "./unit-introduce.vue?vue&type=style&index=0&id=428b67e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428b67e2",
  null
  
)

export default component.exports